"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var SearchIcon_1 = __importDefault(require("./SearchIcon"));
var apps_shared_1 = require("@l2p/apps-shared");
var SearchButton = function (_a) {
    var onClick = _a.onClick;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    return (react_1.default.createElement(react_1.default.Fragment, null, breakpoints.mobile || breakpoints.tablet ? (react_1.default.createElement(SearchIcon_1.default, { onClick: onClick })) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.button, onClick: onClick }, t('search')))));
};
exports.default = SearchButton;
